<ng-http-loader [backdrop]="true" [backgroundColor]="'#292a54'" [debounceDelay]="100" [extraDuration]="1000"
  [minDuration]="2000" [opacity]=".6" spinner="sk-wave" #spinner></ng-http-loader>

<div *ngIf="!allClaims" class="fc-login-bg">
  <nav class="fc-login-navbar">
    <div class="fc-login-logo">
      <img src="/assets/images/otis-logo-white.png" alt="OTIS">
    </div>
    <div class="fc-login-nav-right">
      <button class="fc-login-btn" (click)="login()">
        <i class="fa fa-sign-in-alt fc-btn-icon"></i>
        <span class="fc-btn-text">Login</span>
      </button>
    </div>
  </nav>
  <div class="fc-login-center">
    <div class="fc-center-content">
      <h1 class="fc-center-title">Factory Commissioning</h1>
    </div>
  </div>
</div>
<div *ngIf="isAutenticate" class="fc-app-shell">
  <div class="fc-app-shell-content">
  <header class="col-12 d-inline-flex p-0">
    <div id="hamburger" [class.change]="isSortMenu" (click)="isSortMenu=!isSortMenu">
      <em class="fas fa-th hb-open"></em>
      <em class="fas fa-chevron-left hb-close"></em>
    </div>
    <span id="projectName" class="col-8">
      <span class="pn-brand">OTIS</span>
      <span class="pn-divider">|</span>
      <span class="pn-title">Factory Commissioning</span>
    </span>
    <div class="col text-right">
      <div ngbDropdown class="d-inline-block lt-hd-dropdown">
        <button class="btn fc-profile-btn" id="dropdownBasic1" ngbDropdownToggle>
          <span class="fc-profile-avatar"><i class="fa fa-user-circle"></i></span>
          <span class="fc-profile-name">{{ loginName }}</span>
          <i class="fa fa-chevron-down fc-profile-caret"></i>
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="fc-profile-menu">
          <div class="fc-profile-menu-header">
            <i class="fa fa-user-circle fc-menu-avatar-icon"></i>
            <div class="fc-menu-user-info">
              <span class="fc-menu-name">{{ loginName }}</span>
              <span class="fc-menu-email">{{ loginEmail }}</span>
            </div>
          </div>
          <div class="fc-profile-menu-divider"></div>
          <button ngbDropdownItem class="fc-menu-item" (click)="open(versionModal)">
            <i class="fa fa-info-circle"></i> Version Info
          </button>
          <button ngbDropdownItem class="fc-menu-item" (click)="openUserManual()">
            <i class="fa fa-book"></i> User Manual
          </button>
          <div class="fc-profile-menu-divider"></div>
          <button ngbDropdownItem class="fc-menu-item fc-menu-logout" (click)="logout()">
            <i class="fa fa-sign-out"></i> Logout
          </button>
        </div>
      </div>
    </div>
  </header>
  <section class="col-12 p-0 d-inline-flex">
    <nav [class.iconsMenu]="isSortMenu" id="fcMenu" class="col p-0">
      <li class="nav-item" routerLink="/home" title="Dashboard">
        <span>
          <em class="fas fa-home"></em>
        </span>
        <a class="nav-link">Dashboard</a>
      </li>
      <li class="nav-item" routerLink="/provisioning" title="Provisioning">
        <span>
          <em class="fa fa-cloud-upload"></em>
        </span>
        <a class="nav-link">Provisioning</a>
      </li>
      <li class="nav-item" routerLink="/biprovision" title="Service & MOD Datapoint Provisioning">
        <span>
          <em class="fa fa-cubes"></em>
        </span>
        <a class="nav-link">Service & MOD Datapoint Provisioning</a>
      </li>
      <li class="nav-item" routerLink="/gateway" title="Gateway">
        <span>
          <em class="fa fa-rss"></em>
        </span>
        <a class="nav-link">Commission Gateway</a>
      </li>
      <li class="nav-item" routerLink="/commissioning" title="CPIB2 Commissioning">
        <span>
          <em class="fa fa-microchip" aria-hidden="true"></em>
        </span>
        <a class="nav-link">CPIB Commission</a>
      </li>
      <li class="nav-item" routerLink="/epalcommission" title="ePAL Commissioning">
        <span>
          <em class="fa fa-tablet"></em>
        </span>
        <a class="nav-link"> ePAL Commission</a>
      </li>
      <li class="nav-item" routerLink="/g3msunitsearch" title="G3MS Unit Search">
        <span>
          <em class="fa fa-search"></em>
        </span>
        <a class="nav-link"> G3MS Units</a>
      </li>
      <li *ngIf="enableEDIOrder" class="nav-item" routerLink="/ediorders" title="EDI Orders">
        <span>
          <em class="fa fa-clipboard"></em>
        </span>
        <a class="nav-link">EDI Orders</a>
      </li>
      <li *ngIf="isAdmin" [routerLinkActive]="['active']" class="nav-item" routerLink="/usermanagement"
        title="User Management">
        <span>
          <em class="fa fa-users"></em>
        </span>
        <a class="nav-link">User Management</a>
      </li>
      <li class="nav-item" routerLink="/reports" title="Reports">
        <span>
          <em class="fa fa-file-excel-o"></em>
        </span>
        <a class="nav-link">Reports</a>
      </li>
      <li class="nav-item" routerLink="/history" title="Unit History">
        <span>
          <em class="fa fa-history"></em>
        </span>
        <a class="nav-link">Unit History</a>
      </li>
      <li [routerLinkActive]="['active']" class="nav-item" routerLink="/license" title="License">
        <span>
          <em class="fa fa-file-text-o"></em>
        </span>
        <a class="nav-link">License</a>
      </li>
    </nav>
    <main id="fcMainContent" class="col p-0">
      <router-outlet></router-outlet>
    </main>
  </section>
  <footer class="col-12">
    <img class="fc-footer-img"  src="../assets/images/otis-logo-white.png">
  </footer>
  </div>
</div>

<div *ngIf="showSessionTimeoutWarning" class="fc-session-warning-overlay" role="presentation">
  <div class="fc-session-warning" role="dialog" aria-modal="true" aria-labelledby="session-timeout-title" aria-describedby="session-timeout-message">
    <div class="fc-session-warning-title-row">
      <span id="session-timeout-title" class="fc-session-warning-title">Session expiring soon</span>
      <span class="fc-session-warning-timer">{{ sessionCountdownDisplay }}</span>
    </div>
    <p id="session-timeout-message" class="fc-session-warning-message">You will be logged out due to inactivity unless you continue your session.</p>
    <div class="fc-session-warning-actions">
      <button #continueSessionButton type="button" class="btn fc-session-warning-btn fc-session-warning-btn-primary" (click)="continueSession()">Continue</button>
      <button type="button" class="btn fc-session-warning-btn fc-session-warning-btn-secondary" (click)="logout(true)">Logout</button>
    </div>
  </div>
</div>

<!-- Version Modal  Popup HTML -->
<ng-template #versionModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="modal-basic-title">Version Info</h5>
    <button type="button" class="close" aria-label="Close" (click)="modalClose('Cross click')">
      <em class="fa fa-times"></em>
    </button>
  </div>
  <div class="modal-body">
    <div class="col-12 search-ft p-2 mt-3">
      <div class="row">
        <div class="col">
          <div class="form-group">
            <p class="text-style">App Name : {{ appVersion["AppName"] }}</p>
            <p class="text-style">App Version : {{ appVersion["AppVersion"] }}</p>
            <p class="text-style">G3MS Version : {{ appVersion["G3MSVersion"] }}</p>
            <p class="text-style">CIMS Version : {{ appVersion["CIMSVersion"] }}</p>
            <p class="text-style">Build Date : {{ appVersion["BuildDate"] }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-primary mr-2" (click)="modalClose('Save click')">Close</button>
  </div>
</ng-template>